import { stringify } from "querystring";

export default class Util{
    static Poker_Color_Type = {
        FangKuai : 1,
        MeiHua :2,
        HongTao :3,
        HeiTao : 4,
    }

    static getImageNameFromCard(card: any) : string{
        let strName = ""
        if (card == null) { return  strName}
        let number = card.number == 14 ? 1 : card.number
        switch(card.color){
            case (this.Poker_Color_Type.FangKuai):
                strName = "Public_fangkuai_" + number
                break;
            case (this.Poker_Color_Type.MeiHua):
                strName = "Public_meihua_" + number
                break;  
            case (this.Poker_Color_Type.HongTao):
                strName = "Public_hongxin_" + number
                break;  
            case (this.Poker_Color_Type.HeiTao):
                strName = "Public_heitao_" + number
                break;       
            default:
                break;
        }
        return strName
    }

    static getBjlImageNameFromCard(card: any) : string{
        let strName = ""
        if (card == null) { return  strName}
        let number = card.number == 14 ? 1 : card.number
        switch(card.color){
            case (this.Poker_Color_Type.FangKuai):
                strName = "Public_fangkuai_" + number
                break;
            case (this.Poker_Color_Type.MeiHua):
                strName = "Public_meihua_" + number
                break;  
            case (this.Poker_Color_Type.HongTao):
                strName = "Public_hongtao_" + number
                break;  
            case (this.Poker_Color_Type.HeiTao):
                strName = "Public_heitao_" + number
                break;       
            default:
                break;
        }
        return strName
    }

     // JS格式化数字（每三位加逗号）
    static toThousands(num: any, isInt:boolean = false) {
        let numStr: string =  typeof(num)   == "number" ? (num.toFixed(2) || 0).toString() : num

        let result = '';
        let arr = numStr.split(".");
        let beforeStr = arr[0];

        while (beforeStr.length > 3) {
            result = ',' + beforeStr.slice(-3) + result;
            beforeStr = beforeStr.slice(0, beforeStr.length - 3);
        }
        if (beforeStr) { result = beforeStr + result; }
        if (isInt){ return result}
        if(arr.length > 1)
        {
            result = result + "." + arr[1];
        }
        return result;
    }
}